import React from 'react'
import { object, string } from 'prop-types'
import { linkResolver } from '../util/linkResolver'

import * as Styled from './styles/SearchResultItem.styles'

const isExternalUrl = href => /^https?:\/\//i.test(href)

const SearchResultItem = ({ result, queryString }) => {
  const pruned = result.content.substr(
    result.content.toLowerCase().indexOf(queryString.toLowerCase()),
    280
  )
  const excerpt =
    pruned.length > 20 ? `...${pruned}...` : result.content.substr(0, 280)

  const href =
    result.url || linkResolver({ type: result.type, uid: result.slug })
  const external = isExternalUrl(href)

  const content = (
    <>
      <Styled.SearchResultTitle>{result.title}</Styled.SearchResultTitle>
      <Styled.SearchResultContent>{excerpt}</Styled.SearchResultContent>
    </>
  )

  if (external) {
    return (
      <Styled.SearchResultItemExternal
        href={href}
        target="_blank"
        rel="noopener noreferrer"
      >
        {content}
      </Styled.SearchResultItemExternal>
    )
  }

  return <Styled.SearchResultItem to={href}>{content}</Styled.SearchResultItem>
}

SearchResultItem.propTypes = {
  result: object,
  queryString: string,
}

export default SearchResultItem
